import React from "react";
import moment from "moment";
import { Card, Button, Select } from "antd";
import "./SiteSpeedLayout.less";
import SiteSpeedChart from "./SiteSpeedChart";
import ReportCardTitle from "../shared/ReportCardTitle/ReportCardTitle";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";

const { Option } = Select;

function SiteSpeedLayout(props) {
  let selectRegions = React.createRef();

  function getGroupBy(interval) {
    if (interval === "last_24_hours") {
      return "hour";
    }
    return "day";
  }

  function getEndDate(interval) {
    const groupBy = getGroupBy(interval);
    const currentDate = moment().utc();
    let endDate = currentDate.format("YYYY-MM-DDT00:00:00");

    if (groupBy === "hour") {
      endDate = currentDate.format("YYYY-MM-DDTHH:mm:ss");
    }

    return endDate;
  }

  function getStartDate(interval) {
    const endDate = moment(getEndDate(interval));
    let startDate;

    if (interval === "last_24_hours") {
      startDate = endDate.subtract(24, "hours");
    }

    if (interval === "last_7_days") {
      startDate = endDate.subtract(7, "days");
    }

    if (interval === "last_30_days") {
      startDate = endDate.subtract(30, "days");
    }

    return startDate.format("YYYY-MM-DDTHH:mm:ss");
  }

  function onChangeInterval(intervalType) {
    props.changeSelectedInterval(props.url, props.intervals[intervalType]);
    const interval = props.intervals[intervalType];
    const endDate = getEndDate(interval);
    const startDate = getStartDate(interval, endDate);
    const groupBy = getGroupBy(interval);
    props.getData(props.url, props.selectedRegion, interval, startDate, endDate, groupBy);
  }

  function onChangeRegion(region) {
    const interval = props.selectedInterval;
    const endDate = getEndDate(interval);
    const startDate = getStartDate(interval, endDate);
    const groupBy = getGroupBy(interval);
    props.changeSelectedRegion(props.url, region);
    props.getData(props.url, region, interval, startDate, endDate, groupBy);
    selectRegions.current.blur();
  }

  function handleButtonClass(interval) {
    if (props.intervals[interval] === props.selectedInterval) {
      return "active";
    }
    return "";
  }

  return (
    <Card
      title={<ReportCardTitle title={"Site Speed overview"} domain={props.url} />}
      extra={
        <div className="regions-select">
          <span>From region: </span>
          <Select
            className="monitor-locations"
            style={{ width: 200 }}
            defaultValue={props.regions[0]}
            onChange={onChangeRegion}
            ref={selectRegions}>
            {props.monitorLocations &&
              props.regions.map(region => (
                <Option value={region} key={region}>
                  {props.monitorLocations[region]}
                </Option>
              ))}
          </Select>
        </div>
      }
      data-cy="site-speed">
      {!props.isLoading ? (
        <React.Fragment>
          <SiteSpeedChart chartData={props.loadingTimeData} selectedInterval={props.selectedInterval} />

          <div className="site-speed-buttons">
            <Button className={handleButtonClass("24_hours")} onClick={_ => onChangeInterval("24_hours")}>
              Last 24 hours
            </Button>
            <Button className={handleButtonClass("7_days")} onClick={_ => onChangeInterval("7_days")}>
              Last 7 days
            </Button>
            <Button className={handleButtonClass("30_days")} onClick={_ => onChangeInterval("30_days")}>
              Last 30 days
            </Button>
          </div>
        </React.Fragment>
      ) : (
        <LoadingIndicator />
      )}
    </Card>
  );
}

export default SiteSpeedLayout;
